import React from 'react';
import PropTypes from 'prop-types';

const HeaderLeft = ({ children }) => <div className="ws-my-navbar__left">{children}</div>;

HeaderLeft.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default HeaderLeft;
